<template>
  <div v-if="sf_account_info!=null && sfdcSearchEnabled && ifUserCanAccess">
    <account-page v-if="sf_account_info!=null && ifUserCanAccess"
                  :prop_account_page_obj="sf_account_info"
                  :prop_user_sites="userSites"
                  :prop_user="login_user_name"
                  :prop_user_roles="userRoles" />
  </div>

</template>
<script>
  export default {
    name: 'account-master-gage',
    data() {
      return {
        function_name: 'Account Master Page',
        sf_account_info: null,
        account_id: encodeURIComponent(this.$route.params.account_id),
        frontEndUrlToUse: this.$session.get('frontEndUrlToUse'),
        searching: false,
        userFunctions: null,
        userRoles: null,
        userSites: null,
        login_user_name: null,
        accountFields: [
          { key: 'OPPORTUNITY_NUMBER__C', label: 'Opportunity Number', thClass: 'align-middle', sortable: true },
          { key: 'OPPORTUNITY_NAME', label: 'Opportunity Name', thClass: 'align-middle', sortable: true },
          { key: 'STAGE', label: 'Stage', thClass: 'align-middle', sortable: true },
          { key: 'CREATEDDATE', label: 'Created Date', thClass: 'align-middle', tdClass: 'min-w-200', sortable: true },
          { key: 'LASTMODIFIEDDATE', label: 'Lastmodified Date', thClass: 'align-middle', sortable: true }
        ],
        dateFormat: { year: 'numeric', month: 'short', day: 'numeric' },
        task_page_obj: null,

      }
    },
    created() {
      let self = this;
      self.checkLoggedIn();
      self.getAccountInfo();
      self.sfdcSearchEnabled();
      // self.ifUserCanAccess();
      if (self.sf_account_info !== null) {
        console.log("created MASTER self.sf_account_info");
        if (self.ifUserCanAccess != true) {
          console.log("created MASTER self.sf_account_info ifUserCanAccess");
          console.log(self.ifUserCanAccess);
          self.sf_account_info = null;

          this.$message.error(`You do not have permissions to access Salesforce Account Information from this region.\nPlease contact FTIE system administrators.`);
        }
      } 
    },
    mounted: function () {
      let self = this;
    },
    computed: {
    },
    methods: {
      getAccountInfo() {
        // /opportunity/back-end/opty-id/<str:opty_id>
        let self = this;

        let requestData = {
          account_id: self.account_id,
        };
        eventHub.$emit('loading', true);
        this.$axios
          .post(self.$root.baseUrl + '/opportunity/back-end/account-id/' + self.account_id, requestData)
          .then(res => {
            let result = res.data;

            if (_.get(result, 'account_info', null) !== null) {
              self.sf_account_info = JSON.parse(result.account_info);
            }
          })
          .finally(() => {
            eventHub.$emit('loading', false);
            if (self.opty_id !== null) {
              console.log("self.sf_account_info");
              console.log(self.sf_account_info);
            }

          });
      },
      sfdcSearchEnabled() {
        let self = this;
        if (
          (self.userRoles && (_.indexOf(self.userRoles, 'Admin') > -1 || (_.indexOf(self.userRoles, 'ES_PM_Leader') > -1)
            && self.userSites && _.indexOf(self.userSites, 'Getac') > -1)
            || (self.userFunctions && _.indexOf(self.userFunctions, 'Customer Success Manager') > -1))
        ) {
          console.log("Account Master Page Search Enabled!!");
          return true
        }
        if (((self.userSites && _.indexOf(self.userSites, 'GUSA') > -1 && self.userRoles && _.indexOf(self.userRoles, 'GRO_SA') > -1) && self.userRoles && (_.indexOf(self.userRoles, 'GRO_SA_Leader') > -1 || _.indexOf(self.userRoles, 'GRO_SA') > -1))) {
          console.log("Account Master Page  Search Enabled!!");
          return true
        }
        console.log("Account Master Page  Search Disabled!!");
        // this.$message.error(`You do not have permissions to access Salesforce Account Information.\nPlease contact FTIE system administrators.`);
        return false;

      },
      ifUserCanAccess() {
        let self = this;
        if (self.sfdcSearchEnabled()) {
          if (((self.userSites && _.indexOf(self.userSites, 'GUSA') > -1 && self.userRoles && _.indexOf(self.userRoles, 'GRO_SA') > -1) && self.userRoles && (_.indexOf(self.userRoles, 'GRO_SA_Leader') > -1 || _.indexOf(self.userRoles, 'GRO_SA') > -1))) {
            console.log("[Account Master Page] Can only view US opty for GUSA SA !!");
            if (_.get(self.sf_account_info, 'COUNTRY__C', '') === "United States") {
              return true
            }
            else {
              console.log("[Account Master Page] ifUserCanAccess -- retun false");
              return false
            }
          }
          console.log("[Account Master Page] Return true Account Page sfdcSearchEnabled is true, belong to admin/key account")
          return true;
        } else {
          return false
        }

      },

      checkLoggedIn() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }
        console.log("this.$session.has('user_name')");
        console.log(this.$session.has('user_name'));
        var user_name = this.$session.get('user_name');
        var options = this.$session.get('options');
        var user_email = this.$session.get('user_id');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');

        /*
        console.log("this.$session.get('options')");
        console.log(options);
        console.log(options.model_list);
        console.log("login_user_name:");
        console.log(user_name);
        console.log("user_email:");
        console.log(user_email);
        console.log("user_functions:");
        console.log(user_functions);
        console.log("user_roles:");
        console.log(user_roles);
        console.log("user_site:");
        console.log(user_site);
        */


        this.login_user_name = user_name

        this.userFunctions = user_functions;
        this.userRoles = user_roles;
        this.userSites = user_site;

        }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/opty-management/AccountMasterPage.vue